module.exports = __webpack_public_path__ + "09_hair_brown.f12d5e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/09_hair_brown.png
// module id = LFrn
// module chunks = 0